import React from 'react';
import { MegaMenuColumn } from '../MegaMenuColumn';
import classNames from 'classnames';
import { useMegaMenuState } from '../MegaMenuState';
import './MegaMenuNavigation.scss';

interface MegaMenuNavigationProps {
  levels: number;
}

export const MegaMenuNavigation = ({ levels }: MegaMenuNavigationProps) => {
  const { data } = useMegaMenuState();

  return (
    <div className={'l-megaMenu-navigation-new-main'}>
      {/* For every level add an empty placeholder div to render column using portals.
     For first level we start rendering MegaMenu */}
      {Array(levels)
        .fill(0)
        .map((_, prevLevel) => {
          const level = prevLevel + 1;
          const columns = 'Columns' in data ? data.Columns : data.ColumnAndSection;

          return (
            <div key={level} className={classNames('l-megaMenu-navigation-col', `level-${level}`)}>
              {level === 1 && <MegaMenuColumn level={1} items={columns} />}
            </div>
          );
        })}
    </div>
  );
};
